import { FC, Fragment, useState } from 'react';
import { KeyboardArrowDown as ArrowDownIcon, KeyboardArrowUp as ArrowUpIcon } from '@mui/icons-material';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
// components
import DataLoader from 'components/common/DataLoader';
import FormulaNutrientsWeightsCard from './NutrientsWeightsCard';
// constants, interfaces
import { TFormulaLoading } from 'interfaces';
import { NO_NUTRIENTS_FOUND_TEXT } from 'constants/index';

const FormulaIngredientNutrients: FC<TFormulaLoading> = ({ costing, loading }) => {
  const { formulaIngredients } = costing || {};

  const [itemOpenState, setItemOpenState] = useState(Array(formulaIngredients?.length)?.fill(false));

  const handleItemClick = (index: number) => {
    const newOpenState = [...itemOpenState];
    newOpenState[index] = !newOpenState[index];
    setItemOpenState(newOpenState);
  };

  return (
    <Fragment>
      {loading ? (
        <DataLoader columns={12} rows={6} />
      ) : (
        formulaIngredients?.map((item, index) => {
          const { macroNutrientsWeight, microNutrientsWeight, id, ingredient } = item || {};
          const { name } = ingredient || {};

          return (
            <Fragment key={id}>
              <Box
                flex={1}
                paddingX={2}
                paddingY={1}
                mt={1.5}
                display="flex"
                borderRadius={1}
                alignItems="center"
                bgcolor={'primary.main'}
                onClick={() => handleItemClick(index)}>
                <Typography variant="caption" fontWeight={700} flex={1}>
                  {name}
                </Typography>

                <IconButton aria-label="expand row" size="small">
                  {itemOpenState[index] ? <ArrowUpIcon /> : <ArrowDownIcon />}
                </IconButton>
              </Box>

              <Collapse in={itemOpenState[index]} timeout="auto" unmountOnExit>
                {macroNutrientsWeight || microNutrientsWeight ? (
                  <FormulaNutrientsWeightsCard
                    key={id}
                    macroNutrientsWeight={macroNutrientsWeight}
                    microNutrientsWeight={microNutrientsWeight}
                  />
                ) : (
                  <Typography variant="body2" padding={2} fontWeight="bold">
                    {`${NO_NUTRIENTS_FOUND_TEXT}`}
                  </Typography>
                )}
              </Collapse>
            </Fragment>
          );
        })
      )}
    </Fragment>
  );
};

export default FormulaIngredientNutrients;
